module.exports = __webpack_public_path__ + "static/img/temp-pc-main02@w.3461fa0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ezn-foundation/temp-pc-main02@w.jpg
// module id = x3Te
// module chunks = 0